export const styles = {
  emptyState: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    bgcolor: "grey100",
    border: "1px solid",
    borderColor: "grey400",
    borderRadius: "16px",
    p: { xs: "20px 16px", sm: "60px" },
  },
};
